import React from 'react';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt, FaArrowRight } from 'react-icons/fa';
import { useLang } from '../context/LangContext';

function ResourceCard({ resource, index, featured }) {
  const { t } = useLang();
  const fallbackIcon = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(resource.link)}&sz=64`;

  // Extract domain from URL
  let domain = '';
  try {
    domain = new URL(resource.link).hostname.replace('www.', '');
  } catch {
    domain = '';
  }

  // Generate a consistent color based on category name
  const categoryColors = [
    { bg: 'rgba(99, 102, 241, 0.12)', text: '#818cf8', border: 'rgba(99, 102, 241, 0.3)', glow: 'rgba(99, 102, 241, 0.15)' },
    { bg: 'rgba(34, 211, 238, 0.12)', text: '#22d3ee', border: 'rgba(34, 211, 238, 0.3)', glow: 'rgba(34, 211, 238, 0.15)' },
    { bg: 'rgba(244, 114, 182, 0.12)', text: '#f472b6', border: 'rgba(244, 114, 182, 0.3)', glow: 'rgba(244, 114, 182, 0.15)' },
    { bg: 'rgba(52, 211, 153, 0.12)', text: '#34d399', border: 'rgba(52, 211, 153, 0.3)', glow: 'rgba(52, 211, 153, 0.15)' },
    { bg: 'rgba(251, 191, 36, 0.12)', text: '#fbbf24', border: 'rgba(251, 191, 36, 0.3)', glow: 'rgba(251, 191, 36, 0.15)' },
    { bg: 'rgba(168, 85, 247, 0.12)', text: '#a855f7', border: 'rgba(168, 85, 247, 0.3)', glow: 'rgba(168, 85, 247, 0.15)' },
    { bg: 'rgba(251, 146, 60, 0.12)', text: '#fb923c', border: 'rgba(251, 146, 60, 0.3)', glow: 'rgba(251, 146, 60, 0.15)' },
    { bg: 'rgba(96, 165, 250, 0.12)', text: '#60a5fa', border: 'rgba(96, 165, 250, 0.3)', glow: 'rgba(96, 165, 250, 0.15)' },
  ];

  const colorIndex = resource.category_name
    ? resource.category_name.split('').reduce((a, c) => a + c.charCodeAt(0), 0) % categoryColors.length
    : 0;
  const catColor = categoryColors[colorIndex];

  return (
    <Link
      to={`/resource/${resource.slug}`}
      className={`resource-card ${featured ? 'resource-card-featured' : ''}`}
      style={{ '--cat-glow': catColor.glow, '--cat-border': catColor.border, '--cat-text': catColor.text, '--cat-bg': catColor.bg }}
    >
      {/* Rank number for trending */}
      {typeof index === 'number' && (
        <span className="card-rank">#{index + 1}</span>
      )}

      {/* Category color strip at top */}
      <div className="card-color-strip" style={{ background: `linear-gradient(90deg, ${catColor.text}, transparent)` }} />

      <div className="card-icon-area">
        <div className="card-icon-wrapper">
          <img
            src={resource.icon_url || fallbackIcon}
            alt={resource.name}
            className="card-icon"
            onError={(e) => { e.target.src = fallbackIcon; }}
          />
        </div>
      </div>

      <div className="card-content">
        <h3 className="card-title">{resource.name}</h3>
        {resource.description && (
          <p className="card-description">{resource.description}</p>
        )}
        <div className="card-meta">
          {resource.category_name && (
            <span className="card-category" style={{ background: catColor.bg, color: catColor.text, borderColor: catColor.border }}>
              {resource.category_name}
            </span>
          )}
          {domain && (
            <span className="card-domain">
              <FaExternalLinkAlt /> {domain}
            </span>
          )}
        </div>
      </div>

      <div className="card-visit-btn">
        <span>{t('details')}</span>
        <FaArrowRight />
      </div>
    </Link>
  );
}

export default ResourceCard;
